import React, { useContext, useMemo, useState, useEffect } from 'react';
import "./news-detail.scss";
import { Link, useParams } from "react-router-dom";
import { Buffer } from 'buffer';
import { AppContext } from '../../services/translationContext';
import { Loader } from '../../components/loader/loader';
import axios from 'axios';
import XMLParser from 'react-xml-parser';
import SeoHelmet from '../../components/SeoHelmet';

const api = process.env.REACT_APP_URL_API;
const pathUrl = process.env.REACT_APP_BASE_URL;
// https://d3t3s6w5yvhc3g.cloudfront.net/images/blog/mk-efaktura.png
const textstring = `
<p> Sydea is proud to announce that it has achieved <b>Odoo Silver Partner</b> status, an important milestone that recognizes the company's growth journey within the Odoo ecosystem. </p> <p> Since joining the Odoo partner network, Sydea has strengthened its expertise on the platform by expanding its team of certified consultants and successfully delivering implementation and customization projects. Achieving Silver Partner status reflects the quality of our work and our ongoing commitment to providing businesses with innovative and reliable ERP solutions. </p> <h2><b>A Recognition of Expertise and Experience</b></h2> <p> Silver Partner status is awarded to partners who demonstrate a high level of technical and consulting expertise, invest in the continuous training of their teams, and successfully support companies throughout their digital transformation journeys. </p> <p> For Sydea, this achievement is a tangible recognition of the expertise we have developed and the trust we have built with our customers. </p> <h2><b>Even Closer to Our Customers' Needs</b></h2> <p> Achieving Silver Partner status further strengthens Sydea's ability to support companies throughout every stage of their projects, from process analysis and solution design to implementation and ongoing support. </p> <p> Our extensive experience in the ERP sector, combined with our expertise in system integration and software development, enables us to deliver solutions that integrate seamlessly with our customers' IT ecosystems, unlocking the full potential of Odoo. </p> <div style=' border-left: 3px solid #fece2f; padding-left: 12px; margin-left: 0; color: #555; font-size: 0.9rem; display: flex; flex-direction: column; padding: 0.2rem 0.6rem; font-family: Georgia, Times, serif; ' > <p style='margin: 0'> Becoming an Odoo Silver Partner is an important confirmation of the work our team has accomplished over the past few years. We will continue investing in our expertise and the quality of our services to provide our customers with ERP solutions that are increasingly effective, flexible, and designed to support their growth. </p> <p style='text-align: right; margin: 0; margin-top: 0.2rem'> <b>Tony De Vivo, CEO of Sydea</b> </p> </div> <h2><b>A Journey of Continuous Growth</b></h2> <p> This new milestone marks another step forward in Sydea's growth journey and further strengthens our partnership with Odoo. </p> <p> Our goal remains to help businesses digitize their processes through a modern, comprehensive, and constantly evolving platform, backed by specialized expertise, consulting services, and a value-driven approach. </p> <p> Achieving Silver Partner status is not a destination, but a motivation to keep growing by investing in innovation and in the success of the companies that choose Sydea as their ERP partner. </p>
`;

// https://d3t3s6w5yvhc3g.cloudfront.net/media/presentazione-hd.mp4

export const NewsDetail = () => {
  let { news_id, lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);
  const [newsInfo, setNewsInfo] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch(
          `${pathUrl}/static/content/blog.json?_cache_buster=${new Date().getTime()}`, {cache: 'no-store'}
        );
        if (!response.ok) {
          throw new Error(`Errore HTTP ${response.status}`);
        }
        const data = await response.json();
        const story = data[lang].find((x) => x.id === news_id);
        if (story && story.id !== newsInfo?.id) {
          setNewsInfo(story);
        }
      } catch (err) {
        console.error("Errore nel caricamento del blog:", err);
        setError("Impossibile caricare la notizia.");
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, [news_id]);
  
  const articleUrl = `https://www.sydea.com/${lang}/insights/blog/${news_id}`;

  const articleImageUrl = useMemo(() => {
    if (!newsInfo?.image_url) return undefined;
    return newsInfo.image_url.startsWith('http')
      ? newsInfo.image_url
      : `https://www.sydea.com${newsInfo.image_url.startsWith('/') ? '' : '/'}${newsInfo.image_url}`;
  }, [newsInfo]);

  const breadcrumbSchema = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `https://www.sydea.com/${lang}` },
      { "@type": "ListItem", position: 2, name: TranslationsService.labels(`menu.insights.label`), item: `https://www.sydea.com/${lang}/insights` },
      { "@type": "ListItem", position: 3, name: "Blog", item: `https://www.sydea.com/${lang}/insights/blog` },
      { "@type": "ListItem", position: 4, name: newsInfo.title, item: articleUrl }
    ]
  }), [lang, newsInfo, articleUrl]);

  const articleSchema = useMemo(() => {
    if (!newsInfo?.title) return null;
    return {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      headline: newsInfo.title,
      description: newsInfo.desc,
      image: articleImageUrl,
      datePublished: newsInfo.date_published,
      dateModified: newsInfo.date_modified || newsInfo.date_published,
      author: {
        "@type": "Organization",
        name: newsInfo.author || "Sydea",
        url: "https://www.sydea.com"
      },
      publisher: {
        "@type": "Organization",
        name: "Sydea",
        logo: {
          "@type": "ImageObject",
          url: " https://www.sydea.com/images/logo/sydea-logo.png"
        }
      },
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": articleUrl
      }
    };
  }, [newsInfo, articleImageUrl, articleUrl]);

  // useEffect(() => {
  //   if (newsInfo?.title) {
  //     document.title = `Blog - ${newsInfo.title} | ${TranslationsService.getMainInfoCompany("name")}`;
  //   }
  // }, [newsInfo]);

   if (loading) return <p>Caricamento in corso...</p>;

  return (
    <div className="section-home light">
      {
        newsInfo?.title &&
        <SeoHelmet
          title={`Blog - ${newsInfo.title} | ${TranslationsService.getMainInfoCompany("name")}`}
          description={newsInfo.desc}
          image={articleImageUrl}
          schema={articleSchema ? [articleSchema, breadcrumbSchema] : [breadcrumbSchema]}
        />
      }
      {
        showLoader &&
        <Loader />
      }
      <section className='hero-story-det syd-hero position-relative p-0' style={{backgroundImage: `url(${newsInfo.image_url})`}}>
        <div className='overlay-area-info w-100 d-flex flex-column justify-content-center'>
          <div className='box-text-section'>
            <div className='area-text-section'>
              <p className='dark-mode-text m-0 breadcrumb-detail'>
                <Link to={`/${lang}`}  className='text-deco-none dark-mode-text transition-03s-eio'>Home</Link>
                &nbsp;&#9656;&nbsp;
                <Link to={`/${lang}/insights`} className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`menu.insights.label`)}</Link>
                &nbsp;&#9656;&nbsp;
                <Link to={`/${lang}/insights/blog`} className='text-deco-none dark-mode-text transition-03s-eio'>Blog</Link>
              </p>
              <h2 className='title-insights-section fw-bold font-title'>{newsInfo.title}</h2>
              {/* <p className='dark-mode-text fs-4 m-0'>{newsInfo.desc}</p> */}
              <div className='insights-desc-box'>
                <div className='box-line-insights-desc'>
                  <div className='line-insights-desc'></div>
                </div>
                <div className='box-text-insights-desc'>
                  <div className='box-format-text-insights'>
                    <p className='dark-mode-text syd-body-article-p m-0'>{newsInfo.desc}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className='syd-article-container'>
        <div className='body-text area-text-cs syd-body-article-p syd-art-paper'>
          <div dangerouslySetInnerHTML={{ __html: newsInfo.long_text }}></div>
          {/* <div dangerouslySetInnerHTML={{ __html: textstring }}></div> */}
        </div>

        {
          Object.keys(newsInfo).length > 0 && newsInfo.bu_area.key &&
          <div className='d-flex flex-wrap p-3'>

            <Link to={`/${lang}/services/${newsInfo.bu_area.key}`} className='syd-chips transition-03s-eio text-deco-none syd-black breadcrumb-detail' style={{color:'#141414'}}>
              <p className='m-0'>{TranslationsService.labels(`services.${newsInfo.bu_area.key}.title`)}
              {
                newsInfo.bu_area.sub_items &&
                <span> - {TranslationsService.labels('services')[newsInfo.bu_area.key].items[newsInfo.bu_area.sub_items].title}</span>
              }
              </p>
            </Link>
            
            {
              newsInfo.bu_service?.map((service, i) => (
                newsInfo.bu_area.sub_items ?
                (
                  <Link key={i} to={`/${lang}/services/${newsInfo.bu_area.key}/${newsInfo.bu_area.sub_items}/${service}`} className='syd-chips transition-03s-eio text-deco-none syd-black breadcrumb-detail' style={{color:'#141414'}}>
                    <p className='m-0 text-end'>{TranslationsService.labels('services')[newsInfo.bu_area.key].items[newsInfo.bu_area.sub_items][service].title}</p>
                  </Link>
                )
                :
                (
                  <Link key={i} to={`/${lang}/services/${newsInfo.bu_area.key}/${service}`} className='syd-chips transition-03s-eio text-deco-none syd-black breadcrumb-detail' style={{color:'#141414'}}>
                    <p className='m-0'>{TranslationsService.labels(`services.${newsInfo.bu_area.key}.${newsInfo.bu_service}.title`)}</p>
                  </Link>
                )
              ))
            }

          </div>
          }
      </div>

    </div>
  );
};
